import { Button } from "@material-ui/core";
import Slider from "react-slick";
import { useData } from "../../context/DataContext";
import Head from "../Head";
import "./about.css";
// import Facebook from "./Facebook";
// import Features from "./Features";
// import Tiktok from "./Tiktok";
// import TypingSection from "./TypingSection";

const Banners = () => {
  const { about_banners } = useData();
  return (
    <Slider autoplay={true} autoplaySpeed={3000} pauseOnHover={false}>
      {about_banners?.photos?.map((el) => {
        return (
          <div className="">
            {el.type === "image" ? (
              <img className="w-100 cover" src={el.src} alt={el.src} />
            ) : el.type === "video" ? (
              <video
                autoPlay
                loop
                playsInline
                className={"w-100 cover"}
                src={el?.src}
              ></video>
            ) : (
              <div>The File You've uploaded is not Correct</div>
            )}
          </div>
        );
      })}
    </Slider>
  )
};

const About = () => {
  const { about_banners,about_link } = useData();

  return (
    <main style={{ overflowX: `hidden` }}>
      <Head title="About" />
      {about_banners.id && <Banners />}
      <div className="text-center">
        <div className="my-3">
          <Button
            component="a"
            variant="contained"
            color="primary"
            className="text-decoration-none px-4"
            href={about_link.link}
            disabled={!about_link.link}
          >
            {about_link.link_text}
          </Button>
        </div>
        </div>
      {/* {about_link.id && <TypingSection />}
      {about_section_3.id && <Facebook />}
      {about_section_4.id && <Features />}
      {about_section_2.id && <Tiktok />} */}
    </main>
  );
};

export default About;
